import {
    temAcesso
} from '@/shared/auth/temAcesso'

const Usuarios = () => import('./Usuarios.vue')
const UsuarioForm = () => import('./UsuarioForm.vue')
const UsuarioDetalhar = () => import('./UsuarioDetalhar.vue')
const UsuarioPerfisAcesso = () => import('./UsuarioPerfisAcesso.vue')

export default {
    path: 'usuarios',
    name: 'Usuarios',
    component: Usuarios,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CTRLACS-USR-00')) {
            next()
        }
    },
    children: [{
            path: 'inserir',
            name: 'Usuarios_Inserir',
            component: UsuarioForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CTRLACS-USR-01')) {
                    next()
                }
            }
        },
        {
            path: 'detalhar/:usuarioId',
            name: 'Usuarios_Detalhar',
            component: UsuarioDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CTRLACS-USR-02')) {
                    next()
                }
            }
        },
        {
            path: 'atualizar/:usuarioId',
            name: 'Usuarios_Atualizar',
            component: UsuarioForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CTRLACS-USR-03')) {
                    next()
                }
            }
        },
        {
            path: 'perfisacesso/:usuarioId',
            name: 'Usuarios_PerfisAcesso',
            component: UsuarioPerfisAcesso,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CTRLACS-USR-06')) {
                    next()
                }
            }
        }
    ]
}
